import { render } from "./DragScroll.vue?vue&type=template&id=5b687a0f"
import script from "./DragScroll.vue?vue&type=script&lang=js"
export * from "./DragScroll.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DragScroll.vue?vue&type=style&index=0&id=5b687a0f&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__